var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailLender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86594 7.50777L2.21373 4.14482H13.5182L7.86594 7.50777ZM13.5182 12.2153H2.21373V5.49025L7.86594 8.85279L13.5182 5.49025V12.2153ZM13.5182 2.7998H2.21373C1.437 2.7998 0.808199 3.40544 0.808199 4.14482L0.800781 12.2153C0.800781 12.9551 1.437 13.5603 2.21373 13.5603H13.5182C14.2949 13.5603 14.9311 12.9551 14.9311 12.2153V4.14482C14.9311 3.40544 14.2949 2.7998 13.5182 2.7998Z",
    fill: "#00093A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLender);
export default __webpack_public_path__ + "static/media/EmailLender.8a3a7e9baf5d6d662c11b1cd12ae72c6.svg";
export { ForwardRef as ReactComponent };